var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-component"},[_c('div',{staticClass:"logo",on:{"click":_vm.BackToHome}},[_vm._v(" C-GRAN ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }